export default __webpack_public_path__ + "static/media/first.0ef9c91d.png";